import { useNavigate, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';
import { STRATEGY_PARAM_KEYS } from './navigationConstants';
import { applySearchParamUpdate } from 'utils/browserUtils';

export type CreateNewStrategyNavigationState = {
  showCreateModal: boolean;
};

export type UseCreateNewStrategyNavigationReturn =
  CreateNewStrategyNavigationState & {
    setShowCreateModal: (show: boolean) => void;
  };

export const useCreateNewStrategyNavigation =
  (): UseCreateNewStrategyNavigationReturn => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const showCreateModal =
      searchParams.get(STRATEGY_PARAM_KEYS.createMode) === 'true';

    const setShowCreateModal = (show: boolean) => {
      const newSearchParams = new URLSearchParams(searchParams.toString());

      applySearchParamUpdate(
        newSearchParams,
        STRATEGY_PARAM_KEYS.createMode,
        show ? 'true' : null,
      );

      navigate({
        pathname: PATH.STRATEGIES,
        search: newSearchParams.toString(),
      });
    };

    return {
      showCreateModal,
      setShowCreateModal,
    };
  };
